// extracted by mini-css-extract-plugin
export default {"EventDetailPage":"EventDetailPage_EventDetailPage__vSFUG","content":"EventDetailPage_content__s9coy"};